import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import TableColum from "../../../models/tableColumn";
import DropdownOption from "../../common/DropdownOption";
import SegmentInfo from "../../../models/segmentInfo";
import SegmentInfoField from "../../../models/segmentInfoField";
import Dropdown from "../../common/Dropdown";

const SegmentInfoEdit: React.FC<{
  segmentInfo: SegmentInfo;
  tableColumns: TableColum[];
  onUpdate: any;
  onCancel: any;
}> = ({ segmentInfo: segmentInfoInput, tableColumns, onUpdate, onCancel }) => {
  const [fieldOptions, setFieldOptions] = useState<
    DropdownOption<TableColum>[]
  >([]);

  const [segmentInfo, setSegmentInfo] = useState<SegmentInfo>(
    new SegmentInfo()
  );

  useEffect(() => {
    const options: DropdownOption<TableColum>[] = tableColumns.map((c) => {
      return { value: c, label: c.displayName };
    });

    setFieldOptions(options);

    const newSegmentInfo = { ...segmentInfoInput };
    //newSegmentInfo.segmentInfoFields = [...segmentInfo.segmentInfoFields]; // not needed as add/delete clone them

    updateViewModelFromModel(newSegmentInfo, options);
    setSegmentInfo(newSegmentInfo);
  }, [segmentInfoInput, tableColumns]);

  const updateViewModelFromModel = (
    segmentInfo: SegmentInfo,
    fieldOptions: DropdownOption<TableColum>[]
  ) => {
    for (const field of segmentInfo.segmentInfoFields) {
      const selectedOption = fieldOptions.find(
        (f) => f.value?.columnName === field.fieldName
      );

      if (selectedOption) {
        field.selectedValueOption = selectedOption;
      } else {
        field.selectedValueOption = fieldOptions[0];
      }
    }
  };

  const updateModelFromViewModel = (segmentInfo: SegmentInfo) => {
    let index = 1;
    for (const field of segmentInfo.segmentInfoFields) {
      field.index = index;
      index++;

      if (field.selectedValueOption?.value) {
        field.fieldName = field.selectedValueOption.value.columnName;
      }
    }
  };

  const onNewField = () => {
    const newSegmentInfoField = new SegmentInfoField();

    newSegmentInfoField.selectedValueOption = fieldOptions[0];

    const newSegmentInfo = { ...segmentInfo };
    newSegmentInfo.segmentInfoFields = [...segmentInfo.segmentInfoFields];

    newSegmentInfo.segmentInfoFields.push(newSegmentInfoField);

    setSegmentInfo(newSegmentInfo);
  };

  const onDeleteField = (field: SegmentInfoField) => {
    const newFields = segmentInfo.segmentInfoFields.filter((f) => f !== field);

    const newSegmentInfo = { ...segmentInfo };
    newSegmentInfo.segmentInfoFields = [...newFields];

    setSegmentInfo(newSegmentInfo);
  };

  const onFieldOptionChaged = async (
    newValue: DropdownOption<TableColum>,
    field: SegmentInfoField
  ) => {
    field.selectedValueOption = newValue;

    const newSegmentInfo = { ...segmentInfo };
    newSegmentInfo.segmentInfoFields = [...segmentInfo.segmentInfoFields];

    setSegmentInfo(newSegmentInfo);
  };

  const onShowRoadNameChanged = (event: any) => {
    const checked = event.target.checked;

    const newSegmentInfo = { ...segmentInfo, showRoadName: checked };
    setSegmentInfo(newSegmentInfo);
  };

  const onShowThematicFieldChanged = (event: any) => {
    const checked = event.target.checked;

    const newSegmentInfo = { ...segmentInfo, showThematicField: checked };
    setSegmentInfo(newSegmentInfo);
  };

  const onSave = () => {
    updateModelFromViewModel(segmentInfo);

    onUpdate(segmentInfo);
  };

  return (
    <div style={{ background: "white", padding: "10px", minWidth: "300px" }}>
      <div className="row">
        <div className="mb-3">
          <div className="mb-3">
            <b>Segment Info</b>
          </div>
          <div className="d-flex mb-3">
            <label className="form-check-label" htmlFor="showRoadName">
              Show Road Name
            </label>
            <div className="form-switch form-switch-right-text">
              <input
                className="form-check-input form-switch-right-text"
                type="checkbox"
                checked={segmentInfo.showRoadName}
                onChange={onShowRoadNameChanged}
                id="showRoadName"
              />
            </div>
          </div>
          <div className="d-flex mb-3">
            <label className="form-check-label" htmlFor="showThematicField">
              Show Thematic Field
            </label>
            <div className="form-switch form-switch-right-text">
              <input
                className="form-check-input form-switch-right-text"
                type="checkbox"
                checked={segmentInfo.showThematicField}
                onChange={onShowThematicFieldChanged}
                id="showThematicField"
              />
            </div>
          </div>
          <div
            className="image-button-link d-flex align-items-center"
            onClick={onNewField}
          >
            <AddIcon />
            <div className="image-button-link-text">Add Fields</div>
          </div>
          <div
            className={segmentInfo.segmentInfoFields.length > 0 ? "mt-3" : ""}
          >
            {segmentInfo.segmentInfoFields.map(
              (segmentInfoField: SegmentInfoField, index) => (
                <div key={index.toString()} className="d-flex mb-2">
                  <Dropdown
                    minWidth="200px"
                    options={fieldOptions}
                    value={segmentInfoField.selectedValueOption}
                    onChange={(newValue: any) =>
                      onFieldOptionChaged(newValue, segmentInfoField)
                    }
                  />
                  <div
                    className="image-button-link"
                    onClick={() => onDeleteField(segmentInfoField)}
                  >
                    <ClearIcon />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <div>
          <button className="btn btn-sm btn-primary" onClick={onSave}>
            Save
          </button>
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            style={{ marginLeft: "10px" }}
            onClick={() => {
              onCancel();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SegmentInfoEdit;
